
// Ojo, estos valores deberían cambiar sí en _variables.scss modificamos la variable $grid-breakpoints

const breakpoints = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px) and (max-width: 767px)',
  md: '(min-width: 768px) and (max-width: 991px)',
  lg: '(min-width: 992px) and (max-width: 1199px)',
  xl: '(min-width: 1200px) and (max-width: 1511px)',
  xxl: '(min-width: 1512px)'
};

let lastBreakpoint = null; // Guarda el último breakpoint detectado

// Emitir el evento personalizado
function dispatchBreakpointEvent(currentBreakpoint) {
  const event = new CustomEvent( 'breakpointChange' , {
    detail: { currentBreakpoint, lastBreakpoint }
  });
  lastBreakpoint = currentBreakpoint; // Actualizar el último breakpoint
  window.dispatchEvent( event );
}

function getCurrentBreakpoint( ) {
  return Object.keys(breakpoints).find(breakpoint => {
    const query = breakpoints[breakpoint];
    return window.matchMedia(query).matches;
  }) || 'xs'; // Retorna 'xs' si no hay coincidencias
}

function initBreakpointDetection( ) {
  // Iterar por cada breakpoint
  Object.keys(breakpoints).forEach(breakpoint => {
    const query = breakpoints[breakpoint];
    const mediaQueryList = window.matchMedia(query);
    // Detectar cambios
    const handleChange = () => {
      const currentBreakpoint = getCurrentBreakpoint();
      if (currentBreakpoint !== lastBreakpoint) {
        dispatchBreakpointEvent(currentBreakpoint);
      }
    };
    // Añadir listener y ejecutar inicialmente
    mediaQueryList.addEventListener('change', handleChange);
    handleChange(); // Detectar el estado inicial
  });
}

export { initBreakpointDetection, getCurrentBreakpoint };
